'use client'

import type { EditSaleOrderNoticePortProps } from 'modules/cart'

import EditSaleOrderReminder from './EditSaleOrderReminder'

const EditSaleOrderNotice = ({
  pageType,
  variant
}: EditSaleOrderNoticePortProps) =>
  variant === 'buttons' ? (
    <EditSaleOrderReminder
      pageType={pageType}
      onlyButtons
      buttonsDirection='vertical'
    />
  ) : (
    <EditSaleOrderReminder pageType={pageType} />
  )

export default EditSaleOrderNotice
